// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__enrmK","selected":"Chip_selected__26E19"};